import { useLocation, useNavigate } from 'react-router-dom';
import ReadingPage from './ReadingPage';
import ReadingPlansPage from './ReadingPlansPage';
import './ReadPage.css';

const ReadPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const showPlans = location.hash === '#plans';

  return (
    <div className="read-page">
      <div className="read-tabs" role="tablist" aria-label="Read">
        <button
          type="button"
          role="tab"
          aria-selected={!showPlans}
          className={`read-tab ${!showPlans ? 'read-tab--active' : ''}`}
          onClick={() => navigate('/reading')}
        >
          Bible
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={showPlans}
          className={`read-tab ${showPlans ? 'read-tab--active' : ''}`}
          onClick={() => navigate('/reading#plans')}
        >
          Plans
        </button>
      </div>
      {showPlans ? <ReadingPlansPage /> : <ReadingPage />}
    </div>
  );
};

export default ReadPage;
